import { flushSync } from 'react-dom';

export function withViewTransition(update: () => void) {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('startViewTransition' in document)) {
    update();
    return;
  }
  document.startViewTransition(update);
}

/** Transição de nível (drill-down): `forward` entra pela direita, `back` pela esquerda. */
export function withDrillTransition(direction: 'forward' | 'back', update: () => void) {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('startViewTransition' in document)) {
    update();
    return;
  }
  root.dataset['drill'] = direction;
  const transition = document.startViewTransition(() => flushSync(update));
  void transition.finished.finally(() => delete root.dataset['drill']);
}
